import {
  Checkbox,
  Divider,
  FormControlLabel,
  Typography,
} from '@material-ui/core';
import {
  FilterKeys,
  HandleUpdateCheckboxFilter,
  LabelShowOnlyAvailableProducts,
} from '@src/reducers/shopify/types';
import { FormattedMessage } from 'react-intl';

interface IExtraFilters {
  showOnlyAvailableProductsFilterValue: boolean;
  handleClickOnCheckbox: (value: HandleUpdateCheckboxFilter) => void;
}

const ExtraFilters: React.FC<IExtraFilters> = ({
  showOnlyAvailableProductsFilterValue,
  handleClickOnCheckbox,
}) => (
  <>
    <Divider />
    <FormControlLabel
      value="bottom"
      control={
        <Checkbox
          color="primary"
          size="small"
          checked={showOnlyAvailableProductsFilterValue}
          onChange={event => {
            handleClickOnCheckbox({
              key: FilterKeys.SHOW_ONLY_AVAILABLE_PRODUCTS,
              label: LabelShowOnlyAvailableProducts,
              checked: event.target.checked,
              type: 'checkbox',
            });
          }}
          style={{ paddingLeft: 0 }}
        />
      }
      label={
        <Typography variant="body2">
          <FormattedMessage id={LabelShowOnlyAvailableProducts} />
        </Typography>
      }
      labelPlacement="end"
      style={{
        margin: 0,
      }}
    />
    <Divider />{' '}
  </>
);

export default ExtraFilters;
